import styled from 'styled-components';

export const Controls = styled.section`
display: flex;
  position: absolute;
  z-index: 1;
  bottom: 5px;
  right: 5px;
  gap: 8px;
  z-index: 1;
`;

export const ButtonControl = styled.button`
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  
  &:hover {
    cursor: pointer;
    background-color: transparent;
  }
`;

export const ContainerImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  & img {
    width: 100%;
    height: auto;
    object-fit: contain;
  }
`;

export const ExpandButton = styled.button`
  width: 120px;
  height: 24px;
  padding: 0px 12px 0px 12px;
  gap: 8px;
  border-radius: 100px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  opacity: 0px;
  background-color: ${({ theme }) => theme.colors.surface.low};
  transition: background-color 0.3s;

  font-family: Inter;
  font-size: 12px;
  font-weight: 500;
  line-height: 14.52px;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.primary};

  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colors.surface.high};
  }

`;
